/**
 * Um UUID novo, também no Aeris aberto por `http://` na rede da loja (F250).
 *
 * `crypto.randomUUID` só existe em contexto seguro (https ou localhost). Pelo
 * IP da rede ele não existe, e o F9 do PDV quebraria por inteiro. O
 * `getRandomValues` existe nos dois: com ele, o v4 se monta à mão.
 */
export const newUuid = (): string => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()

  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-')
}
